var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackArrowIcon = function SvgBackArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8741E",
    d: "M.293 5.707a1 1 0 0 1 0-1.414l4-4a1 1 0 0 1 1.414 1.414L3.414 4H19a1 1 0 1 1 0 2H3.414l2.293 2.293a1 1 0 0 1-1.414 1.414z"
  })));
};
export default SvgBackArrowIcon;